import React from 'react';
import Cookies from "js-cookie";

const CustomerAutoFilling_AlreadyRegistered = () => {
    const companyImg = Cookies.get('selfRegistrationImagePath') || null;

    return (
        <div>
            {companyImg && <div style={{textAlign: 'center'}}><img src={companyImg} alt="Logo" style={{maxHeight: '120px', width: 'auto'}}/></div>}
            <div style={{marginTop: '10px', alignItems: 'center', display: 'flex'}}>
                <div style={{textAlign: 'center', width: '100%'}}>Cadastro já realizado!</div>
            </div>
        </div>
    );
};

export default CustomerAutoFilling_AlreadyRegistered;
